export default __webpack_public_path__ + "static/media/at-workspace.1e5921e9.svg";